import { api } from "../../app/api";
import { BASE_API } from "../../constants/apiUrls";
import {
  GetDealerListParams,
  GetDealerListResponseType,
} from "../../types/dealer.type";

export const dealerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDealerList: builder.query<
      GetDealerListResponseType,
      GetDealerListParams
    >({
      query: (queries) => {
        // console.log(queries);
        return {
          url: BASE_API.getDealerList,
          params: { ...queries },
        };
      },
    }),
  }),
});

export const { useGetDealerListQuery } = dealerApi;
